import { render, staticRenderFns } from "./private-commercial-contract-supplier-block.vue?vue&type=template&id=a65ea21e&"
import script from "./private-commercial-contract-supplier-block.vue?vue&type=script&lang=js&"
export * from "./private-commercial-contract-supplier-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65ea21e')) {
      api.createRecord('a65ea21e', component.options)
    } else {
      api.reload('a65ea21e', component.options)
    }
    module.hot.accept("./private-commercial-contract-supplier-block.vue?vue&type=template&id=a65ea21e&", function () {
      api.rerender('a65ea21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/private-commercial-contract-supplier-block.vue"
export default component.exports